export { default as NewDishes } from './NewDishes'
export { default as NewDishesSkeleton } from './Skeleton'
